import { Box } from '@mui/material'
import Users from '../../components/features/Users'

import styles from './styles.module.scss'

const UsersManagementPage = () => {
  return (
    <Box className={`${styles.userManagement} main-container`}>
      <Users />
    </Box>
  )
}

export default UsersManagementPage
